export default "__VITE_ASSET__SqfYOiLo__"